// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexHeader/index.less
// module id = 350
// module chunks = 0